import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "../../../shared/i18n/translate.pipe";

@Component({
  selector: "app-logout-dialog",
  templateUrl: "./logout-dialog.component.html",
  styleUrls: ["./logout-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe],
})
export class LogoutDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<LogoutDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  ngOnInit() {}
}
